import React from "react";
import { Mail } from "lucide-react";
import { CONTACT_EMAIL } from "@/lib/constants";

export const FloatingContact = () => {
    const mailUrl = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Contato — Geomine Manager (GM² ANM)")}`;

    return (
        <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3" data-testid="floating-contact">
            <a href={mailUrl} data-testid="floating-email" className="flex items-center gap-2 group" aria-label="Enviar e-mail">
                <span className="bg-white text-slate-700 text-xs sm:text-sm font-semibold px-4 py-2 rounded-full shadow-md border border-slate-200 whitespace-nowrap">{CONTACT_EMAIL}</span>
                <span className="w-12 h-12 rounded-full bg-petroleum text-white flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform shrink-0">
                    <Mail className="w-6 h-6" />
                </span>
            </a>
        </div>
    );
};

export default FloatingContact;
